// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag--1LKDM","Date":"Date--1RED_"};